export const barChartData = {
  type: 'pie',
  data: {
    labels: ['Profit', 'Invoice', 'Expense'],
    datasets: [
        {
            data: [10, 20, 30],
            backgroundColor: [
              'rgba(255, 99, 132, 0.7)',
              'rgba(54, 162, 235, 0.7)',
              'rgba(255, 206, 86, 0.7)',
              
            ]
        }
    ]
  }
};
  
export default barChartData;